export interface ChromeNavLink {
  label: string
  href: string
}

export interface ChromeNavMenuItem {
  label: string
  href: string
  description: string
}

export interface ChromeNavMenu {
  label: string
  items: ChromeNavMenuItem[]
}

/** Top-level links alongside the Exams and Resources menus. */
export const NAV_LINKS: ChromeNavLink[] = [{ label: 'Books', href: '/books' }]

/** Shared desktop and mobile Resources links. */
export const RESOURCES_MENU: ChromeNavMenu = {
  label: 'Resources',
  items: [
    {
      label: 'Free Materials',
      href: '/free-study-materials',
      description: 'Choose your exam and browse free study resources',
    },
    {
      label: 'Blog',
      href: '/blog',
      description: 'Study guides, exam changes, and pass strategies',
    },
    {
      label: 'Affiliate Program',
      href: '/affiliate-program',
      description: 'Earn 20% on every sale you refer',
    },
  ],
}

/** "Why PrepSolution" dropdown — rendered after the Resources dropdown. */
export const WHY_MENU: ChromeNavMenu = {
  label: 'Why PrepSolution',
  items: [
    {
      label: 'PrepSolution vs Others',
      href: '/why-prepsolution',
      description: 'Feature-by-feature vs the big prep brands',
    },
    {
      label: 'Adaptive Learning',
      href: '/adaptive-learning',
      description: 'The science that powers every session',
    },
  ],
}

export const LOGIN_URL = 'https://app.prepsolution.com/login'
